<template>
  <div class="Login">
    <h1>Sign In</h1>
    <button @click="login">Sign in with Github</button>
    <router-link to="playground">Use without account</router-link>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import firebase from 'firebase/app';
import db from '@/db';
import { auth } from 'firebase';

export default {
  name: 'login',
  data() {
    return {};
  },
  methods: {
    ...mapActions(['setUser']),
    async login() {
      const provider = new firebase.auth.GithubAuthProvider();

      try {
        const { user } = await auth().signInWithPopup(provider);
        const { email, displayName, photoURL } = user;

        db.collection('users')
          .doc(user.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              localStorage.setItem('store', JSON.stringify({ ...doc.data() }));
              this.$store.commit('INITIALISE_STORE');
              this.$router.push('/playground');
            }
          })
          .catch(() => {
            db.collection('users')
              .doc(user.uid)
              .set({
                email,
                displayName,
                picture: photoURL,
                uid: user.uid,
                version: '0.1.0',
                userPreferences: { theme: { name: '' } },
                undocounter: 0,
                searchQuery: '',
                activeTags: [],
                languages: [
                  {
                    id: 'kaxwmhv8',
                    name: 'javascript',
                    isSelected: true,
                    snippets: [
                      {
                        id: 'kaxwmhva',
                        name: 'a beautiful new snippet',
                        isSelected: true,
                        code: 'your awesome new code',
                        description: 'snipp snipp',
                        tags: [],
                        timeStamp: 1591101286390,
                      },
                    ],
                    isInEditMode: false,
                  },
                ],
                tags: [],
              });
            this.$router.push('/playground');
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* "scoped" attribute limit the CSS to this component only */
.Login {
  margin: 0 auto;
  padding-top: 100px;
  width: 400px;

  h1 {
    color: black;
  }
  input {
    margin: 10px 0;
    width: 20%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 100%;
    cursor: pointer;
    color: black;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
